/* Linsoul review posts: GSAP fade-up of head, featured article and rows when the section first scrolls into view. */
(() => {
  'use strict';
  const offscreen = (el) => {
    const r = el.getBoundingClientRect();
    return r.top > window.innerHeight || r.bottom < 0;
  };
  const loadGsap = (src) => (window.gsap ? Promise.resolve(window.gsap) : window.lsLoadGsap ? window.lsLoadGsap(src) : Promise.reject());

  function init(root) {
    if (root.dataset.lrpReady || !('IntersectionObserver' in window)) return;
    root.dataset.lrpReady = '1';
    const near = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      near.disconnect();
      loadGsap(root.dataset.gsapSrc).then((gsap) => {
        gsap.matchMedia().add('(prefers-reduced-motion: no-preference)', () => {
          if (!offscreen(root)) return;
          const items = root.querySelectorAll('[data-lrp-reveal]');
          const imgs = root.querySelectorAll('.lrp-feature__media img');
          gsap.set(items, { autoAlpha: 0, y: 28 });
          gsap.set(imgs, { scale: 1.08 });
          const tl = gsap.timeline({ paused: true, defaults: { ease: 'expo.out', duration: 0.9 } });
          tl.to(items, { autoAlpha: 1, y: 0, stagger: 0.07, clearProps: 'transform,opacity,visibility' }, 0)
            .to(imgs, { scale: 1, duration: 1.4, clearProps: 'transform' }, 0.05);
          const enter = new IntersectionObserver((entries) => {
            if (!entries.some((e) => e.isIntersecting)) return;
            enter.disconnect();
            tl.play();
          }, { rootMargin: '0px 0px -15% 0px' });
          enter.observe(root);
          return () => { enter.disconnect(); tl.kill(); };
        });
      }).catch(() => {});
    }, { rootMargin: '600px 0px' });
    near.observe(root);
  }

  const run = () => document.querySelectorAll('[data-lrp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
